import React from 'react';
import { LinkButton, ListWrapper } from '@builtbypixel/nucleus';
import { Button } from '@chakra-ui/react';

import setup from './setup';

// Extra Menu appears next to the create button.  You can call any component you wish.
// const extraMenu = () => {
//    return (
//       <Flex>
//          <Flex>fdgdsgfddf</Flex>
//       </Flex>
//    )
// }

const extraMenu = () => null;

const List = () => {
  const columns = [
    {
      Header: 'Booking Ref',
      accessor: 'id',
      id: 'edit',
      Cell: ({ row, value }) => (
        <LinkButton to={`${setup.model}/edit/${row.original[setup.accessor]}`}>
          <Button variant='link' variantColor='secondary' rounded='md'>
            {value}
          </Button>
        </LinkButton>
      ),
    },
    {
      Header: 'First Name',
      accessor: 'user.first_name',
    },
    {
      Header: 'Last Name',
      accessor: 'user.last_name',
    },
    {
      Header: 'Deal Status',
      accessor: 'status.name',
    },
    {
      Header: 'Created',
      accessor: 'date_created',
    },
  ];

  return <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />;
};

export default List;
